import React from 'react'
import { CoverContainer, CoverContainerProps } from './coverContainer'
import styles from './imageCover.m.scss'
import { srcSetConfiguration } from '../../lib/srcSetConfigurations'
import clsx from 'clsx'

export function ImageCover(props: CoverContainerProps) {
  const supportsObjectFit =
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports('object-fit', 'cover')

  return (
    <CoverContainer {...props}>
      {supportsObjectFit && (
        <>
          <img
            style={{
              height: props.coverHeight
            }}
            className={clsx(styles.posterImage, styles.landscape)}
            {...props.poster}
            src={props.poster.sources['1800w']}
            srcSet={props.poster.srcSet}
            sizes={srcSetConfiguration.fullWidthSizeHint}
            alt=''
          />
          <img
            style={{
              height: props.coverHeight
            }}
            className={clsx(styles.posterImage, styles.portrait)}
            {...props.portraitPoster}
            src={props.portraitPoster.sources['1800w']}
            srcSet={props.portraitPoster.srcSet}
            sizes={srcSetConfiguration.fullWidthSizeHint}
            alt=''
          />
        </>
      )}

      {!supportsObjectFit && (
        <div
          className={styles.posterFallback}
          style={{
            height: props.coverHeight,
            // The following definition is somewhat flaky, since it depends
            // on a size that has been defined previously in
            // main/srcSetConfigurations.ts, and could change there (and break
            // this).
            backgroundImage: `url(${props.poster.sources['1800w']})`
          }}
        />
      )}
    </CoverContainer>
  )
}
